import { connect } from 'react-redux'
import {
  selectShopifyAllOrdersUrl,
  selectShopifyCustomerUrl,
  selectShopifyOrderUrls,
} from 'selectors/sidebar_cards'
import { doFetchAccountIntegrationData } from 'actions/sidebar_cards'
import logo from 'assets/integrations/shopify.png'
import withCardDataLoading from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/withCardDataLoading'

import ShopifyTitle from './ShopifyTitle'
import View from './view'

const selectFactory = (initialState, initialOwnProps) => {
  const { id: cardId } = initialOwnProps
  const openStateKey = `shopify-${cardId}`
  return state => {
    return {
      errorMessage:
        'Please check your Shopify credentials in your settings and try again.',
      image: logo,
      key: openStateKey,
      openStateKey,
      seeAllOrdersUrl: selectShopifyAllOrdersUrl(state, cardId),
      seeCustomerUrl: selectShopifyCustomerUrl(state, cardId),
      seeOrderUrls: selectShopifyOrderUrls(state, cardId),
      title: ShopifyTitle,
    }
  }
}

const performFactory = (initialState, initialOwnProps) => {
  const { id: cardId } = initialOwnProps
  return dispatch => ({
    load: customerId =>
      dispatch(doFetchAccountIntegrationData('shopify', cardId, customerId)),
  })
}

export default connect(selectFactory, performFactory)(
  withCardDataLoading(View, { useInAppCardView: false, canReload: true })
)
